<template>
  <footer id="footer">
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <p>
            &copy; Copyright 2020
            <a href="#">Kobe</a>. All Rights Reserved
          </p>
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
#footer {
  background-color: #070707;
  p {
    font-size: 16px;
    margin-bottom: 0;
    color: #fff;
  }
}
</style>